import React, {Component} from 'react'
import Wrapper from '../common/Wrapper'
import Submenu from './Submenu'
import { MenuItem} from 'react-bootstrap'
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes'
import history from '../../history'

class CustomItems extends Component {
    static contextTypes = {formatMessage: PropTypes.any};
    render() {
      const {formatMessage} = this.context;
      return <React.Fragment>
        <MenuItem
          onClick={() => {
            history.push(routesUrls.dashboard)
          }}
        >{formatMessage('navTitleDashboard')}</MenuItem>
     </React.Fragment>
    }
  }

let AdminPanel = (props) => {
    let {children} = props
    return (
        <Wrapper renderButtonNav = {false} CustomItems={CustomItems}>
            <Submenu />
            <div className="container content">
                {children}
            </div>
        </Wrapper>
    )
}

export default AdminPanel



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/index.js